// 首页公告（Announcements 分类）
// 原 Zendesk 列表地址（首页 HomeAnnouncement 已改走 /xt-app/public/academy-config/list?configType=2；其它入口如 HomeNotice 仍可能使用本请求）：
// `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284067920670-Announcements/articles.json?sort_by=created_at&sort_order=desc`
import { Bridge, Cookie, Platform } from "@xt/xtbase";

/** 与 ssr-web-user-center KYC Upload action 一致，走相对路径 + 浏览器原生 XHR */
export const EXCHANGE_USER_UPLOAD_FILE_PATH = "/exchange-user/api/web/1_0_0/uploadFile";

function resolveUploadAuthToken() {
  return (Platform.isInApp() ? Bridge.getToken() : null) || Cookie.get("token") || "";
}

/**
 * POST uploadFile — 与 user-center Ant Design Upload 直连接口一致（XHR + 相对路径，无 XtAxios 超时/业务码校验）
 * 响应：{ data: ["https://..."] }
 */
export function post_exchangeUserUploadFile(formData) {
  const token = resolveUploadAuthToken();

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("POST", EXCHANGE_USER_UPLOAD_FILE_PATH);

    if (token) {
      xhr.setRequestHeader("token", token);
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
    }
    xhr.setRequestHeader("device", "web");

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(xhr.responseText ? JSON.parse(xhr.responseText) : null);
        } catch (_) {
          reject(createUploadTransportError("upload", xhr.status));
        }
        return;
      }
      reject(createUploadTransportError("upload", xhr.status));
    };

    xhr.onerror = () => reject(createUploadTransportError("network", xhr.status));
    xhr.onabort = () => reject(createUploadTransportError("network", xhr.status));
    xhr.send(formData);
  });
}

function createUploadTransportError(code, xhrStatus) {
  const error = new Error(code);
  error.xhrStatus = xhrStatus;
  return error;
}

export function getZendeskNotices(lang) {
  // 原列表请求（保留备查；HomeNotice 等仍依赖下方 fetch）：
  // return fetch(`https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284067920670-Announcements/articles.json?sort_by=created_at&sort_order=desc`);
  return fetch(
    `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284067920670-Announcements/articles.json?sort_by=created_at&sort_order=desc`
  ).then(
    (res) => res.json(),
    () => []
  );
}

/**
 * Spikex 学院（Academy 分类）
 * 源管理页（参考）：https://spikex.zendesk.com/knowledge/arrange/categories/5284051234846?brand_id=5156836483742
 * 请求结构与 Announcement 保持一致，额外透传 brand_id 以便 Zendesk 路由到对应品牌的 Help Center。
 * 原 Zendesk 列表地址（首页 HomeAnnouncement 已改走 /xt-app/public/academy-config/list?configType=1）：
 * `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284051234846-Academy/articles.json?sort_by=created_at&sort_order=desc`
 */
export function getZendeskAcademy(lang) {
  // 原列表请求（保留备查）：
  // return fetch(`https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284051234846-Academy/articles.json?sort_by=created_at&sort_order=desc`);
  return fetch(
    `https://spikex.zendesk.com/api/v2/help_center/${lang}/categories/5284051234846-Academy/articles.json?sort_by=created_at&sort_order=desc`
  ).then(
    (res) => res.json(),
    () => []
  );
}
